import { HeaderStylesProvider } from './HeaderStylesContext';
import { OpenShareMenuProvider } from './OpenShareContext';

export const Providers = ({ children }) => (
  <HeaderStylesProvider>
    <OpenShareMenuProvider>{children}</OpenShareMenuProvider>
  </HeaderStylesProvider>
);
